export const getAuthInfoFromStorage = () => {
    const auth = localStorage.getItem('auth');
    return auth ? JSON.parse(auth) : {};
  }
  
export const setAuthInfoInStorage = auth => {
    const stringifiedAuth = JSON.stringify(auth);
    localStorage.setItem('auth', stringifiedAuth);
}